import { getUIBlockerStyle } from './blocker';

export const getAudienceSelectorStyle = (_, { palette = {} }) => ({
  ...getUIBlockerStyle({ palette }),

  selectorContainer: {
    '& .ms-Panel-content': {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      overflowY: 'auto',
      padding: '0 24px',

      '& .audience-description': {
        margin: '16px 0',
      },

      '& .audience-search-box': {
        marginBottom: 8,
      },

      '& .audience-list': {
        flexGrow: 1,
        overflowY: 'overlay',
        margin: '0 -24px',
        padding: '0 24px',

        '& .audience-card': {
          border: 'none',
          borderRadius: 4,
          boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.08)',
          marginBottom: 8,
          padding: 24,

          '&:focus, &:hover': {
            backgroundColor: palette.neutralLighterAlt,
            cursor: 'pointer',
          },

          '& .audience-header': {
            marginBottom: 8,

            '& .audience-highlight': {
              fontSize: 16,
            },

            '& button': {
              height: 24,
            },
          },
        },
      },

      '& .campaign-details-list-pagination': {
        margin: '20px 0',
      },
    },

    '& .ms-Panel-footer': {
      backgroundColor: palette.white,
      borderTop: `1px solid ${palette.neutralLight}`,
    },
  },
});
